import axios from "axios";

const CRM_API = axios.create({
  baseURL: "https://crm.smartscholars360.com",
});

CRM_API.interceptors.request.use((req) => {
  const token = localStorage.getItem("crm_token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

CRM_API.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      ["crm_token", "crm_user", "crm_role", "crm_user_id"].forEach((k) =>
        localStorage.removeItem(k)
      );
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default CRM_API;
